import { gql } from 'graphql.macro';

export const GetOpportunityCompletionLookups = gql`

    query GetOpportunityenumlookup($request: NearMissEnumLookupRequestInput) {
        closureReasons: nearmissenumlookup(request: $request) {
            id
            name: type
            description
        }
    }
`;
